"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _classnames = _interopRequireDefault(require("classnames"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdTable = _interopRequireDefault(require("cccisd-table"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _LackingPermissions = _interopRequireDefault(require("../../components/LackingPermissions"));
var _Overlay = _interopRequireDefault(require("../../components/Overlay"));
var _Sticky = _interopRequireDefault(require("../../components/Sticky"));
var _messageConditionTranslator = _interopRequireDefault(require("../../helpers/messageConditionTranslator.js"));
var _questPermissionsByArea = _interopRequireDefault(require("../../helpers/questPermissionsByArea.js"));
var _MessageViewer = _interopRequireDefault(require("./MessageViewer"));
var _SaveMessageModalContents = _interopRequireDefault(require("./SaveMessageModalContents.js"));
var _ScheduleMessageModalContents = _interopRequireDefault(require("./ScheduleMessageModalContents.js"));
var _style = _interopRequireDefault(require("./style.css"));
var _style2 = _interopRequireDefault(require("../../components/ModalContents/style.css"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _atSign = _interopRequireDefault(require("cccisd-icons/at-sign"));
var _mobile = _interopRequireDefault(require("cccisd-icons/mobile"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil5"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _quill = _interopRequireDefault(require("cccisd-icons/quill2"));
var _alarmCheck = _interopRequireDefault(require("cccisd-icons/alarm-check"));
var _history = _interopRequireDefault(require("cccisd-icons/history"));
var _alarm = _interopRequireDefault(require("cccisd-icons/alarm"));
var _alarmCancel = _interopRequireDefault(require("cccisd-icons/alarm-cancel"));
var _copy = _interopRequireDefault(require("cccisd-icons/copy3"));
var _addressBook = _interopRequireDefault(require("cccisd-icons/address-book"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Fortress = window.cccisd.fortress;

// *** CONSTANTS ***
var DRAFT = 'draft';
var TEMPLATE = 'template';
var SCHEDULED = 'scheduled';
var SENT = 'completed';
var VIEW = 'view';
var DATE_FORMAT_MOMENT = 'D MMM YYYY, h:mm A';
var Messaging = /*#__PURE__*/function (_React$Component) {
  _inherits(Messaging, _React$Component);
  var _super = _createSuper(Messaging);
  function Messaging() {
    var _this;
    _classCallCheck(this, Messaging);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      loading: false,
      tzAbbrev: _momentTimezone["default"].tz(_momentTimezone["default"].tz.guess()).format('z') // Why in state?
    });
    _defineProperty(_assertThisInitialized(_this), "deleteMessage", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(messageId) {
        var isSuccess;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setState({
                  loading: true
                });
                _context.next = 3;
                return _this.props.deleteMessage(_this.props.deployment.deploymentId, messageId);
              case 3:
                isSuccess = _context.sent;
                _this.setState({
                  loading: false
                });
                if (isSuccess) {
                  (0, _cccisdNotification["default"])('Message successfully deleted');
                } else {
                  (0, _cccisdNotification["default"])({
                    type: 'danger',
                    message: 'Message failed to delete'
                  });
                }
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "unscheduleMessage", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(messageId, label) {
        var isSuccess;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.setState({
                  loading: true
                });
                _context2.next = 3;
                return _this.props.unscheduleMessage(_this.props.deployment.deploymentId, messageId);
              case 3:
                isSuccess = _context2.sent;
                _this.setState({
                  loading: false
                });
                if (isSuccess) {
                  (0, _cccisdNotification["default"])("Successfully deleted scheduling for '".concat(label, "'"));
                } else {
                  (0, _cccisdNotification["default"])({
                    type: 'danger',
                    message: "Failed to delete scheduling for '".concat(label, "'")
                  });
                }
              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return function (_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "_renderNewSavedButton", function (type) {
      var deploymentId = _this.props.deployment.deploymentId;
      var messageList = _this.props.messageList;
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].rightSide
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("a", {
          className: (0, _classnames["default"])(_style["default"].addButton, 'btn btn-primary btn-sm'),
          type: "button"
        }, /*#__PURE__*/_react["default"].createElement(_plus["default"], null), "\xA0\xA0Create Message"),
        title: /*#__PURE__*/_react["default"].createElement("span", {
          className: _style2["default"].title
        }, "Create a new message"),
        formAutoFocus: true
      }, /*#__PURE__*/_react["default"].createElement(_SaveMessageModalContents["default"], {
        deploymentId: deploymentId,
        messageList: messageList,
        hideMessageReplacementNotes: _this.props.hideMessageReplacementNotes,
        requeryCallback: _this.props.reloadCurrentProject
      })));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderActionButtons", function (id, tableType, sendDateString) {
      tableType = tableType.toLowerCase();
      var deploymentId = _this.props.deployment.deploymentId;
      var messageList = _this.props.messageList;
      // get message object by messageId
      var messageObject = (0, _find2["default"])(messageList, function (msg) {
        return msg.messageId === id;
      });

      // RETURN - if no object
      if (messageObject === undefined) {
        return;
      }
      var viewButton = /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: (0, _classnames["default"])('btn btn-default btn-xs', _style["default"].fullWidthBtn)
        }, messageObject.messageMethod === 'email' ? /*#__PURE__*/_react["default"].createElement(_atSign["default"], null) : /*#__PURE__*/_react["default"].createElement(_mobile["default"], null), " Preview"),
        title: /*#__PURE__*/_react["default"].createElement("span", {
          className: _style2["default"].title
        }, "Previewing message"),
        size: messageObject.messageMethod === 'email' ? 'large' : 'small'
      }, /*#__PURE__*/_react["default"].createElement(_MessageViewer["default"], {
        messageObject: messageObject,
        sendDateStr: sendDateString
      }));
      var editButton = /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Edit"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-success btn-xs"
        }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null)),
        title: /*#__PURE__*/_react["default"].createElement("span", {
          className: _style2["default"].title
        }, "Edit".concat(tableType !== 'template' ? " {tableType}" : '', " message '").concat(messageObject.settings.label, "'")),
        formAutoFocus: true
      }, /*#__PURE__*/_react["default"].createElement(_SaveMessageModalContents["default"], {
        deploymentId: deploymentId,
        messageList: messageList,
        hideMessageReplacementNotes: _this.props.hideMessageReplacementNotes,
        isEditing: true,
        messageObj: messageObject,
        requeryCallback: _this.props.reloadCurrentProject
      })));
      var deleteButton = /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Delete"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-danger btn-xs",
        onClick: function onClick() {
          (0, _cccisdConfirm["default"])({
            message: 'Confirm delete?',
            description: "Are you sure you want to delete message '".concat(messageObject.settings.label, "' and any of its unsent scheduled messages?"),
            confirmLabel: 'Yes',
            abortLabel: 'Cancel'
          }).then(function () {
            _this.deleteMessage(id);
          });
        }
      }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null)));
      var editScheduleButton = messageObject.scheduleTime === null ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Edit Message"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-success btn-xs"
        }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null)),
        title: /*#__PURE__*/_react["default"].createElement("span", {
          className: _style2["default"].title
        }, "Edit ", tableType, " message"),
        formAutoFocus: true
      }, /*#__PURE__*/_react["default"].createElement(_SaveMessageModalContents["default"], {
        deploymentId: deploymentId,
        messageList: messageList,
        hideMessageReplacementNotes: _this.props.hideMessageReplacementNotes,
        isEditing: true,
        messageObj: messageObject,
        requeryCallback: _this.props.reloadCurrentProject
      }))) : /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Edit this Schedule"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-success btn-xs"
        }, /*#__PURE__*/_react["default"].createElement(_alarm["default"], null)),
        title: /*#__PURE__*/_react["default"].createElement("span", {
          className: _style2["default"].title
        }, "Change schedule for '".concat(messageObject.settings.label, "'"))
      }, /*#__PURE__*/_react["default"].createElement(_ScheduleMessageModalContents["default"], {
        messageObj: messageObject,
        requeryCallback: _this.props.reloadCurrentProject,
        deploymentId: deploymentId,
        isEditing: true
      })));
      var deleteScheduleButton = messageObject.scheduleTime === null ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Delete Message"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-danger btn-xs",
        onClick: function onClick() {
          (0, _cccisdConfirm["default"])({
            message: 'Confirm message delete?',
            description: "Are you sure you want to delete scheduled message '".concat(messageObject.settings.label, "'?"),
            confirmLabel: 'Yes',
            abortLabel: 'Cancel'
          }).then(function () {
            _this.deleteMessage(id);
          });
        }
      }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null))) : /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Delete this Schedule"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-danger btn-xs",
        onClick: function onClick() {
          (0, _cccisdConfirm["default"])({
            message: 'Confirm schedule delete?',
            description: "Are you sure you want to delete this schedule for template '".concat(messageObject.settings.label, "'?"),
            confirmLabel: 'Yes',
            abortLabel: 'Cancel'
          }).then(function () {
            _this.unscheduleMessage(id, messageObject.settings.label);
          });
        }
      }, /*#__PURE__*/_react["default"].createElement(_alarmCancel["default"], null)));
      var duplicateButton = /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: tableType === SCHEDULED ? 'Duplicate Message' : 'Duplicate'
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-warning btn-xs"
        }, /*#__PURE__*/_react["default"].createElement(_copy["default"], null)),
        title: /*#__PURE__*/_react["default"].createElement("span", {
          className: _style2["default"].title
        }, "Duplicate ".concat(tableType, " message '").concat(messageObject.settings.label, "'")),
        formAutoFocus: true
      }, /*#__PURE__*/_react["default"].createElement(_SaveMessageModalContents["default"], {
        deploymentId: deploymentId,
        messageList: messageList,
        hideMessageReplacementNotes: _this.props.hideMessageReplacementNotes,
        messageObj: _objectSpread(_objectSpread({}, messageObject), {}, {
          settings: _objectSpread(_objectSpread({}, messageObject.settings), {}, {
            label: "".concat(messageObject.settings.label, " (duplicate)")
          })
        }),
        requeryCallback: _this.props.reloadCurrentProject
      })));
      switch (tableType) {
        case VIEW:
          return /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].viewButton
          }, viewButton);
        case DRAFT: // fall-through
        case TEMPLATE:
          return /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].actionButtons
          }, editButton, duplicateButton, deleteButton);
        case SCHEDULED:
          return /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].actionButtons
          }, editScheduleButton, messageObject.scheduleTime === null && duplicateButton, deleteScheduleButton);
        case SENT:
          return;
        default:
          // safety - edit button
          return /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].actionButtons
          }, editButton);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "styleMessageTypeLabel", function (text) {
      switch (text.toUpperCase()) {
        case 'EMAIL':
          return 'Email';
        case 'SMS':
          return 'SMS/Text';
        default:
          return text;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "dateTimeFormat", function (datetime) {
      if (datetime === null) {
        return '—';
      }
      return "".concat((0, _momentTimezone["default"])(_momentTimezone["default"].utc(datetime).format()).format(DATE_FORMAT_MOMENT), " (").concat(_this.state.tzAbbrev, ")");
    });
    _defineProperty(_assertThisInitialized(_this), "_renderConditionColumn", function (value) {
      return (0, _messageConditionTranslator["default"])(value);
    });
    _defineProperty(_assertThisInitialized(_this), "_renderMethodCell", function (message, time) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].messageTypeCell
      }, /*#__PURE__*/_react["default"].createElement("span", null, _this.styleMessageTypeLabel(message.messageMethod)), _this._renderActionButtons(message.messageId, VIEW, time === '' ? '' : _this.dateTimeFormat(time)));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderToCell", function (message) {
      var showMsgCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var numRecs = message.recipients ? message.recipients.length : 0;
      var recBtn = /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn btn-xs btn-default"
      }, numRecs, " ", /*#__PURE__*/_react["default"].createElement(_addressBook["default"], null));
      var respBtn = /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Sent to ".concat(message.messageCount, " Respondent").concat(message.messageCount !== 1 ? 's' : ''),
        placement: "right"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn btn-xs btn-default"
      }, message.messageCount));
      var recipientTypes = ['on_respondent_complete_notify', 'on_respondent_complete_module_notify', 'on_respondent_complete_survey_notify', 'scheduled', 'scheduled_on_respondent_complete_notify', 'scheduled_on_respondent_complete_module_notify', 'scheduled_on_respondent_complete_survey_notify', 'scheduled_target_met', 'target_met', 'target_not_met'];
      return recipientTypes.includes(message.condition) ? /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].recList
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Receiver List"), /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].hoverHelp
      }, numRecs === 0 ? recBtn : /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: message.recipients.join('<br />'),
        placement: "right"
      }, recBtn))) : /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].recList
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Respondent(s)"), showMsgCount && /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].hoverHelp
      }, respBtn));
    });
    return _this;
  }
  _createClass(Messaging, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var deployment = this.props.deployment;
      // RETURN - if no data
      if (!deployment) {
        return /*#__PURE__*/_react["default"].createElement("h1", null, "NO DATA");
      }
      if (!Fortress.hasAnyAccess([].concat(_toConsumableArray(_questPermissionsByArea["default"].deploy.permissions), ['quest.messaging']), deployment.assignment.groupId)) {
        return /*#__PURE__*/_react["default"].createElement(_LackingPermissions["default"], null);
      }

      // tables' columns
      var templateColumns = [{
        name: 'label',
        label: 'Label',
        sort: true,
        filter: true
      }, {
        name: 'method',
        label: 'Message Type',
        sort: true,
        filter: false
      }, {
        name: 'recipients',
        label: 'Recipients',
        sort: true,
        filter: false
      }, {
        name: 'condition',
        label: 'Condition',
        render: this._renderConditionColumn,
        sort: true,
        filter: true
      }, {
        name: 'lastModified',
        label: 'Last Modified',
        render: this.dateTimeFormat,
        sort: true,
        filter: false,
        filterSettings: {
          type: 'date'
        }
      }, {
        name: 'actions',
        label: 'Actions'
      }];
      var scheduledColumns = [{
        name: 'label',
        label: 'Label',
        sort: true,
        filter: true
      }, {
        name: 'method',
        label: 'Message Type',
        sort: true,
        filter: false
      }, {
        name: 'sendTo',
        label: 'Send To',
        sort: true,
        filter: false
      }, {
        name: 'condition',
        label: 'Condition',
        sort: true,
        filter: true,
        render: this._renderConditionColumn
      }, {
        name: 'sendOn',
        label: 'Send On',
        render: this.dateTimeFormat,
        sort: true,
        filter: false,
        filterSettings: {
          type: 'date'
        }
      }, {
        name: 'actions',
        label: 'Actions'
      }];
      var sentColumns = [{
        name: 'label',
        label: 'Label',
        sort: true,
        filter: true
      }, {
        name: 'method',
        label: 'Message Type',
        sort: true,
        filter: false
      }, {
        name: 'sentTo',
        label: 'Sent To',
        sort: true,
        filter: false
      }, {
        name: 'condition',
        label: 'Condition',
        sort: true,
        filter: true,
        render: this._renderConditionColumn
      }, {
        name: 'sentOn',
        label: 'Sent On',
        render: this.dateTimeFormat,
        sort: true,
        filter: false,
        filterSettings: {
          type: 'date'
        }
      }];

      // tables' data
      var templateData = [];
      var scheduledData = [];
      var sentData = [];
      var skippedConditions = ['scheduled_on_respondent_complete', 'scheduled_on_respondent_complete_notify', 'scheduled_on_respondent_complete_module', 'scheduled_on_respondent_complete_module_notify', 'scheduled_on_respondent_complete_survey', 'scheduled_on_respondent_complete_survey_notify', 'scheduled_on_respondent_rostered'];

      // saved message tables arrays
      (0, _map2["default"])(this.props.messageList, function (message) {
        var onCompleteTypes = ['on_respondent_complete', 'on_respondent_complete_notify', 'on_respondent_complete_module', 'on_respondent_complete_module_notify', 'on_respondent_complete_survey', 'on_respondent_complete_survey_notify', 'on_respondent_rostered'];
        var onCompleteNum = message.category === 'SCHEDULED' && onCompleteTypes.includes(message.condition) && message.messageCount > 0 ? "".concat(message.messageCount) : '';
        if (!skippedConditions.includes(message.condition) && (message.category === 'COMPLETED' || onCompleteNum)) {
          sentData.push({
            id: message.messageId,
            label: message.settings.label,
            method: _this2._renderMethodCell(message, message.completedAt),
            condition: message.condition,
            sentTo: _this2._renderToCell(message, true),
            sentOn: message.completedAt
          });
        }
        if (skippedConditions.includes(message.condition)) {
          // skip
        } else if (message.category === 'SCHEDULED') {
          scheduledData.push({
            id: message.messageId,
            label: message.settings.label,
            method: _this2._renderMethodCell(message, message.scheduleTime),
            condition: message.condition,
            sendTo: _this2._renderToCell(message),
            sendOn: message.scheduleTime,
            actions: _this2._renderActionButtons(message.messageId, message.category, _this2.dateTimeFormat(message.scheduleTime))
          });
        } else if (['DRAFT', 'TEMPLATE'].includes(message.category)) {
          templateData.push({
            id: message.messageId,
            label: message.settings.label,
            method: _this2._renderMethodCell(message, ''),
            recipients: _this2._renderToCell(message),
            condition: message.condition,
            lastModified: message.updatedAt,
            actions: _this2._renderActionButtons(message.messageId, message.category, '')
          });
        }
      });

      // RETURN - normal
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: this.state.loading
      }, /*#__PURE__*/_react["default"].createElement(_Overlay["default"], {
        title: "Messaging",
        backLink: /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
          to: this.props.projectLinks.deploy
        }, this.props.backLinkText),
        breadcrumbs: this.props.breadcrumbs
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].messagingWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].savedArea
      }, /*#__PURE__*/_react["default"].createElement(_Sticky["default"], null, /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Message templates that can be used to create/edit scheduled messages",
        placement: "right"
      }, /*#__PURE__*/_react["default"].createElement("h1", null, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_quill["default"], null)), "Messages")), this._renderNewSavedButton(TEMPLATE))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].tableArea
      }, /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], {
        columns: templateColumns,
        data: templateData,
        hideShowingRowsSummary: true,
        perPage: 25,
        saveState: false,
        showBottomPaginator: true,
        showPerPageOptions: false
      }))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Sticky["default"], null, /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Messages scheduled with a date and time or messages that have a specified send condition",
        placement: "right"
      }, /*#__PURE__*/_react["default"].createElement("h1", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].scheduledIcon
      }, /*#__PURE__*/_react["default"].createElement(_alarmCheck["default"], null)), "Scheduled")))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].tableArea
      }, /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], {
        columns: scheduledColumns,
        data: scheduledData,
        hideShowingRowsSummary: true,
        orderBy: "sendOn",
        perPage: 25,
        saveState: false,
        showBottomPaginator: true,
        showPerPageOptions: false
      }))), sentData.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].sentArea
      }, /*#__PURE__*/_react["default"].createElement(_Sticky["default"], null, /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Messages that have been sent",
        placement: "right"
      }, /*#__PURE__*/_react["default"].createElement("h1", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].sentIcon
      }, /*#__PURE__*/_react["default"].createElement(_history["default"], null)), "Sent")))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].tableArea
      }, /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], {
        columns: sentColumns,
        data: sentData,
        hideShowingRowsSummary: true,
        isAscentOrder: false,
        orderBy: "sentOn",
        perPage: 25,
        saveState: false,
        showBottomPaginator: true,
        showPerPageOptions: false
      }))))));
    }
  }]);
  return Messaging;
}(_react["default"].Component);
exports["default"] = Messaging;
_defineProperty(Messaging, "propTypes", {
  backLinkText: _propTypes["default"].string,
  breadcrumbs: _propTypes["default"].array,
  deleteMessage: _propTypes["default"].func,
  deployment: _propTypes["default"].object,
  messageList: _propTypes["default"].array,
  hideMessageReplacementNotes: _propTypes["default"].bool,
  projectLinks: _propTypes["default"].object,
  reloadCurrentProject: _propTypes["default"].func,
  unscheduleMessage: _propTypes["default"].func
});
_defineProperty(Messaging, "defaultProps", {
  backLinkText: 'Go back to Deploy'
});